import { useContext } from 'react';
import profileRoleContext from 'context/profile-role-context';

const useProfileRole = () => {
  return useContext(profileRoleContext);
};

export default useProfileRole;
